import { render } from "./PersianTimeField.vue?vue&type=template&id=28f487e8"
import script from "./PersianTimeField.vue?vue&type=script&lang=js"
export * from "./PersianTimeField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianTimeField.vue"]])

export default __exports__